var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNexusSwitches(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.75,24V11.81055l2.71973,2.71972,1.06054-1.06054-4-4a.74972.74972,0,0,0-1.06054,0l-4,4,1.06054,1.06054L39.25,11.81055V24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.25,56V68.18945l-2.71973-2.71972-1.06054,1.06054,4,4a.74971.74971,0,0,0,1.06054,0l4-4-1.06054-1.06054L40.75,68.18945V56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.46973,44.53027l1.06054-1.06054L11.81055,40.75H22v-1.5H11.81055l2.71972-2.71973-1.06054-1.06054-4,4a.74972.74972,0,0,0,0,1.06054Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.53027,44.53027l4-4a.74972.74972,0,0,0,0-1.06054l-4-4-1.06054,1.06054L68.18945,39.25H58v1.5H68.18945l-2.71972,2.71973Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.75,46V34a.7502.7502,0,0,0-.75-.75H26a.7502.7502,0,0,0-.75.75V46a.7502.7502,0,0,0,.75.75H54A.7502.7502,0,0,0,54.75,46Zm-1.5-.75H26.75V34.75h26.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 39.25,
    width: 12,
    height: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.68262,32.43408c4.05371-6.05273,4.64062-10.17187,1.84765-12.96435-2.76367-2.76368-7.0332-2.13965-13.05468,1.90771l.83789,1.24512c7.09863-4.77393,9.76855-3.48047,11.15625-2.09229,1.38281,1.3833,2.67773,4.03516-2.03321,11.06885Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.30078,47.58252c-4.042,6.041-4.624,10.15527-1.83105,12.94775a5.65345,5.65345,0,0,0,4.16308,1.72754c2.34375,0,5.23047-1.18066,8.78418-3.5581l-.834-1.24707c-7.01758,4.69629-9.669,3.40039-11.05274,2.01709S17.85059,55.436,22.54688,48.4165Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.59961,22.54883l.834-1.2461c-5.96289-3.99218-10.2041-4.59375-12.96386-1.833-2.79785,2.79687-2.19141,6.94043,1.9082,13.04l1.24414-.83692c-4.76855-7.09473-3.47754-9.75732-2.0918-11.14258C21.917,19.144,24.57324,17.84521,31.59961,22.54883Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.53027,60.53027c2.75977-2.75927,2.16114-6.999-1.83105-12.9624l-1.2461.834c4.70313,7.02587,3.40333,9.68164,2.01661,11.06787-1.37989,1.37939-4.0293,2.67041-11.05274-2.03125l-.834,1.24609c3.56054,2.38428,6.45117,3.56738,8.7959,3.56689A5.63687,5.63687,0,0,0,60.53027,60.53027Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 40,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 40,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNexusSwitches);
export default __webpack_public_path__ + "static/media/icon_nexus_switches.60f104b97dd6b9f50fc777a384749edd.svg";
export { ForwardRef as ReactComponent };